// Plain-Swedish event summaries — keep in sync with backend/event_summary.py
const HEADLINES = {
  vape: 'Tydliga tecken på vape upptäcktes',
  suspect: 'Möjliga tecken på vape – håll uppsikt',
  offline: 'Sensorn har slutat skicka data',
  test_alarm: 'Testlarm – inget verkligt larm',
  normal: 'Luften är tillbaka till normala nivåer',
};

export const ACTIONS = {
  vape: 'Gå till rummet och kontrollera. Kvittera larmet när du är på plats.',
  suspect: 'Håll uppsikt vid nästa rast och kontrollera vid behov.',
  offline: 'Kontakta ansvarig för att kontrollera sensorns ström och nätverk.',
  test_alarm: 'Ingen åtgärd behövs.',
};

const SUBSTANCES = {
  pg_dominant: 'e-cigarett med smaksatt vätska',
  vg_dominant: 'e-cigarett med mycket ånga',
  mixed: 'e-cigarett (blandad vätska)',
  nicotine_salt: 'nikotinvape (nikotinsalt)',
};
const SUBSTANCE_HINTS = { 'pg-dominant': 'pg_dominant', 'vg-dominant': 'vg_dominant', blandad: 'mixed', nikotinsalt: 'nicotine_salt' };

const join = (a) => (a.length === 1 ? a[0] : `${a.slice(0, -1).join(', ')} och ${a[a.length - 1]}`);

export const certaintyLabel = (score) => {
  const s = score || 0;
  const level = s >= 0.8 ? 'Hög' : s >= 0.5 ? 'Medel' : 'Låg';
  return `${level} (${Math.round(s * 100)} %)`;
};

export function summarizeEvent(event) {
  const type = event?.event_type || '';
  const expl = (event?.explanation || '').toLowerCase();
  const headline = type === 'vape' && (event?.score || 0) < 0.8 ? 'Tecken på vape upptäcktes' : (HEADLINES[type] || 'Händelse från sensorn');
  let reason = '';
  if (['vape', 'suspect', 'test_alarm'].includes(type)) {
    const raw = expl.split(/ml\[|\|/)[0];
    const sig = [];
    if (/pm1|pm2_5|pm2\.5|pm10|partik/.test(raw)) sig.push('partiklar');
    if (/voc(?![\s_-]*anti)/.test(raw)) sig.push('kemiska ämnen (VOC)');
    if (/humid|fukt/.test(raw)) sig.push('luftfuktighet');
    if (sig.length) reason = `${type === 'vape' && raw.includes('!') ? 'Kraftig ökning' : 'Förhöjda nivåer'} av ${join(sig)}.`;
  }
  let subType = event?.voc_fingerprint?.substance_type;
  if (!subType || subType === 'unknown') {
    subType = Object.entries(SUBSTANCE_HINTS).find(([k]) => expl.includes(`substans: ${k}`))?.[1];
  }
  const isDetection = type === 'vape' || type === 'suspect';
  const substance = SUBSTANCES[subType];
  return {
    headline,
    reason,
    substance: substance && isDetection ? `Trolig typ: ${substance}` : '',
    certainty: isDetection ? certaintyLabel(event?.score) : '',
    action: ACTIONS[type] || '',
  };
}

export const summaryText = (event) => {
  const s = summarizeEvent(event);
  return [`${s.headline}.`, s.reason, s.substance, s.action && `Gör så här: ${s.action}`].filter(Boolean).join(' ');
};
